// Parámetros previsionales chilenos — fuente única para la liquidación de sueldos.
// Se editan UNA vez al año (o cuando cambian los topes/IMM). Valores 2026.
// Cualquier constante previsional (IMM, topes imponibles, tope gratificación) vive acá,
// NO hardcodeada en el cálculo (src/utils/empleados.js).

export const PREVISIONAL_CHILE_2026 = {
  imm: 539000, // ingreso mínimo mensual
  topeGratificacionMensual: 219115, // tope grat mensual (según liquidación del contador)
  topeImponibleUF: 90, // tope imponible AFP y salud
  topeImponibleCesantiaUF: 135.2, // tope imponible seguro de cesantía
  cargaPatronalPct: 0.052, // carga del EMPLEADOR (SIS + cesantía patronal + mutual aprox);
  // se paga por PreviRed, NO se descuenta al empleado. Dato solo para proyección de PreviRed.
};

// ─── Neteo por motor directo (allowlist TRANSITORIA — Fase B scopeada, P3.17) ────────────────────
// Empleados cuyo saldo de sueldo se computa SIEMPRE contra el líquido del motor
// (calcularLiquidacion<País>), SIN la rama "anclar al recibo" de netearEmpleado. Para estos
// empleados un mes CERRADO (con un pago tipo='sueldo' del período) ya NO oculta el residual: si
// Σpagos del período < líquido del motor, el saldo real aflora en "Movimientos Futuros"
// (ej. Ignacio julio 2026 = $647.968 que el ancla escondía).
//
// Por qué allowlist y NO global: el ancla al recibo existe para tapar "saldos fantasma" cuando el
// motor SOBRE-estima un mes ya liquidado por DEUDA DE DATOS (vigencia histórica sin cargar, o
// comisión pagada fuera de la bolsa de neteo). Sacar el ancla de forma global reintroduciría esos
// fantasmas — Franco ene–may (P3.15, ~$217k) y Nicolás junio (P3.16, $49.850). Por eso el neteo por
// motor puro solo se habilita empleado por empleado, donde la data es confiable y únicamente aflora
// residual REAL.
//
// TRANSITORIO: cuando P3.15 y P3.16 se reconcilien y el motor reproduzca TODOS los recibos, se hace
// la Fase B GLOBAL (netearEmpleado sin rama de ancla) y esta allowlist se retira. Ver ROADMAP P3.17.
//
// Se compara por ID (regla 10.7). UUID = Ignacio Mailhos (Chile).
export const EMPLEADOS_NETEO_MOTOR_DIRECTO = ["9087f8ce-dc97-4427-b0a4-4bf85aef8694"];
